// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"651":"b396e272","736":"7898c0df","887":"b62aec85","2237":"90d048c2","8101":"7898c0df"}[chunkId] + ".css";
};